"use strict";

APP.game.LevelObject = function () {

    // Invoke (needed)
    EHDI.aka.Container.call( this );

    // Constants
    var ADD_SCORE_ON_PLACE  =   5;
    var ADD_SCORE_ON_TICK   =   10;

    // Properties

    // ** Parent (This reference)
    var _parent = this;

    // ** General Values
    var _isPaused, _score;

    // ** Object References
    var _objAnimals, _objCages;

    // ** Graphics
    var _grpSpawn_bottom, _grpSpawn_top,
    _layerBG, _layerDrag, _layerObjects,
    _sprBG, _sprFenceLeft_back,  _sprFenceLeft_front, _sprFenceRight_back, _sprFenceRight_front,
    _sprSign_left, _sprSign_right, _sparkleArmature, _sparkleAnimationSprite;   

    var _interactionMan;

    var scoreEffectXs, scoreEffectY, scoreEffects, _lion, _sfxTimer;
    

    // Private Methods

    // ** General Methods

    /**
     * Rearrange objects.
     */
    var _rearrangeObjects = function () {
        
        // If layer is empty return
        if ( !_layerObjects ) return;
        
        // Go through layer children
        for ( var i = 0; i < _layerObjects.children.length; i++ ) {

            var indexCurrent = ( _layerObjects.children.length - 1 ) - i;
            var childCurrent = _layerObjects.getChildAt( indexCurrent );

            var indexPrev = indexCurrent - 1;
            var childPrev = null;
           
            try { childPrev = _layerObjects.getChildAt( indexPrev ); } 
            catch ( e ) { childPrev = null; }

            if ( childPrev ) {
                
                // If current child y is less than prev child y
                // And current index is greater than prev index
                // Swap children
                if ( childCurrent.y < childPrev.y && indexCurrent > indexPrev ) {
                    
                    _layerObjects.swapChildren( childCurrent, childPrev );
                }
            }
        }
    };

    var _addScore = function ( p_addScore, type ) {
        
        if ( typeof _score !== "number" ) return;

        if(_score == 0)
            _lion.hideTimer = 500;

        _score += p_addScore;

        scoreEffects.popScore(scoreEffectXs[type-1], scoreEffectY, p_addScore);

        APP.managers.event.dispatch( APP.game.LevelEvent.UPDATED_SCORE, { score: _score } );
    };

    var _updateScore = function () {
        
        if(APP.pauseButton)
            {
                if ( APP.pauseButton.isPaused === true || APP.pauseButton.isEndGame === true )
                return;
            }

            if (window.document.webkitHidden || window.document.hidden)
                return;

        if ( !_objAnimals ) return;
        
        var correctGoatCount = 0;
        var correctSheepCount = 0;

        for ( var i = 0; i < _objAnimals.length; i++ ) {

            var objAnimal = _objAnimals[ i ];

            if ( !objAnimal ) continue;

            if ( objAnimal.isCaged === true &&
                 objAnimal.isCageCorrect === true )
                 {
                    if(objAnimal.type ==1)
                        correctGoatCount++;
                    else
                        correctSheepCount++;
                 }
        }

        if ( correctGoatCount > 0 ) _addScore( ADD_SCORE_ON_TICK * correctGoatCount , 1);
        if ( correctSheepCount > 0 ) _addScore( ADD_SCORE_ON_TICK * correctSheepCount, 2 );
    };

    // ** Handlers

    /**
     * Handler for frame update
     * @param {Number} p_delta 
     */
    var _handler_frameUpdate = function ( p_delta ) {

        // Rearrange objects
        _rearrangeObjects();


        
        scoreEffects.update(p_delta);

        if ( APP.game.btnPause ) {
            
                        if ( APP.game.btnPause.isPaused === true || 
                            APP.game.btnPause.isEndGame === true ) return;
                    }

        _sfxTimer -= p_delta;

        if(_sfxTimer <= 0)
        {
            _sfxTimer = EHDI.NumberUtil.randomRange( 3500, 12000 );

            if(Math.random() < 0.5)
                APP.managers.sound.playSFX("goat");
            else
                APP.managers.sound.playSFX("lamb");
        }
        
    };

    /**
     * Handler for animal drag start.
     * @param {Event} e The corresponding event. 
     */
    var _handlerAnimal_dragStart = function ( e ) {
        
        // Check if values are invalid then return
        if ( !e ) return;
        if ( !e.obj ) return;

        if ( !_layerDrag ) return;

        // Set animal object
        var objAnimal = e.obj;

        // Remove object from parent
        if ( objAnimal.parent ) objAnimal.parent.removeChild( objAnimal );

        // Scale up
        if(objAnimal.type !== APP.game.AnimalType.LION)
            objAnimal.scale.set( 1.25 );

        // Add to drag layer
        _layerDrag.addChild( objAnimal );

        // Rearrange objects
        _rearrangeObjects();
    };

    /**
     * Handler for animal drag end.
     * @param {Event} e The corresponding event. 
     */
    var _handlerAnimal_dragEnd = function ( e ) {
        
        // Check if values are invalid then return
        if ( !e ) return;
        if ( !e.obj ) return;

        if ( !_layerObjects ) return;
        if ( !_objCages ) return;

        // Set animal object
        var objAnimal = e.obj;

        if((objAnimal.type === APP.game.AnimalType.SHEEP) ||
            (objAnimal.type === APP.game.AnimalType.GOAT))
        {

            // Check if cage object is hit
            var objCageHit = null;
            
            for ( var i = 0; i < _objCages.length; i++ ) {

                var objCage = _objCages[ i ];

                if ( !objCage.hit ) continue;

                if ( EHDI.CollisionUtil.rectToRect( objCage.hit.getBounds(), objAnimal.getBounds() ) && 
                    !EHDI.CollisionUtil.rectToRect( _grpSpawn_bottom.getBounds(), objAnimal.getBounds() ) && 
                    !EHDI.CollisionUtil.rectToRect( _grpSpawn_top.getBounds(), objAnimal.getBounds() ) ) {

                    objCageHit = objCage;

                    break;
                }
            }

            // Remove object from parent
            if ( objAnimal.parent ) objAnimal.parent.removeChild( objAnimal );

            // Scale to normal
            objAnimal.scale.set( 1 );

            // Add to objects layer
            _layerObjects.addChild( objAnimal );

            // Do according to objCageHit value
            if ( !objCageHit ) {
                
                // If not hit, reset position to initial
                if ( objAnimal.initialPosition ) {

                    objAnimal.x = objAnimal.initialPosition.x;
                    objAnimal.y = objAnimal.initialPosition.y;
                }
            }
            else {

                // If hit,
                objCageHit.disableGlow();

                // Set isCaged to true
                objAnimal.isCaged = true;
                
                // Set isCageCorrect if cage type and animal type is sane
                if ( objCageHit.type === objAnimal.type ) {
                    
                    if ( objAnimal.isCageCorrect === false ) {
                        
                        objAnimal.isCageCorrect = true;

                        _addScore( ADD_SCORE_ON_PLACE, objAnimal.type );
                    }

                }
                else objAnimal.isCageCorrect = false;
                
                // Limit within cage bounds
                // Localize cage bounds
                var boundsCage = objCageHit.hit.getBounds();
                
                var localPosCage = _parent.toLocal( new PIXI.Point( boundsCage.x, boundsCage.y ) );
                var localBoundsCage = objCageHit.hit.getLocalBounds();

                boundsCage = new PIXI.Rectangle( localPosCage.x, localPosCage.y, localBoundsCage.width, localBoundsCage.height );
            
                // Set limits
                var minX = boundsCage.left + ( objAnimal.width * 0.5 );
                var maxX = boundsCage.right - ( objAnimal.width * 0.5 );

                var minY = boundsCage.top;
                var maxY = boundsCage.bottom;

                objAnimal.x = EHDI.NumberUtil.clamp( objAnimal.x, minX, maxX );
                objAnimal.y = EHDI.NumberUtil.clamp( objAnimal.y, minY, maxY );
            }
        }
        // else if(objAnimal.type === APP.game.AnimalType.LION)
        // {

        //     var sideBounds = (50 + objAnimal.width);
        //     if(objAnimal.x < sideBounds|| objAnimal.x> APP.config.stageWidth-sideBounds)
        //         {
        //             objAnimal._hide();
        //         }
        //     else
        //         {
        //             if ( objAnimal.initialPosition ) {
                        
        //                                     objAnimal.x = objAnimal.initialPosition.x;
        //                                     objAnimal.y = objAnimal.initialPosition.y;
        //                                 }
        //         }
        // }


        // Rearrange objects
        _rearrangeObjects();
    };

    /**
     * Handler for animal moving.
     * @param {Event} e The corresponding event. 
     */
    var _handlerAnimal_moving = function ( e ) {

        // Check if values are invalid then return
        if ( !e ) return;
        if ( !e.obj ) return;

        if ( !_objCages ) return;

        // Set animal object
        var objAnimal = e.obj;

        // Check if cage object is hit
        var objCageHit = null;
        
        for ( var i = 0; i < _objCages.length; i++ ) {

            var objCage = _objCages[ i ];

            if ( !objCage.hit ) continue;

            if ( EHDI.CollisionUtil.rectToRect( objCage.hit.getBounds(), objAnimal.getBounds() ) && 
                !EHDI.CollisionUtil.rectToRect( _grpSpawn_bottom.getBounds(), objAnimal.getBounds() ) && 
                !EHDI.CollisionUtil.rectToRect( _grpSpawn_top.getBounds(), objAnimal.getBounds() ) ) {

                objCageHit = objCage;

                break;
            }
        }

        // Do according to objCageHit value
        if ( !objCageHit ) {

            // Set isCaged to false
            objAnimal.isCaged = false;

            // Set isCageCorrect to false
            objAnimal.isCageCorrect = false;
        }
    }

    var _interactionLayer_move= function ( e ) 
    {
        var propName = "interactId_"+e.data.identifier;

        // console.log(APP.game.TouchObjects[propName]);
        if(APP.game.TouchObjects[propName] == null)
            return;
        
        APP.game.TouchObjects[propName].interactMove(e);
    }

  

    // ** Initialization Methods

    /**
     * Initialize properties.
     */
    var _initProps = function () {

        // Initialize properties
        _isPaused = false;
        _score = 0;        
        _sfxTimer = EHDI.NumberUtil.randomRange( 500, 3500 );
        
        _interactionMan = new PIXI.interaction.InteractionManager(APP.managers.scene.getRenderer());
    };

    
    /**
     * Initialize graphics
     */
    var _initGraphics = function () {
        
        // Initialize graphics

        // ** Initialize layers
        if ( !_layerBG ) {

            _layerBG = new EHDI.aka.Container();

            if ( _parent ) _parent.addChild( _layerBG );
        }

        if ( !_layerObjects ) {

            _layerObjects = new EHDI.aka.Container();

            if ( _parent ) _parent.addChild( _layerObjects );
        }

        if ( !_layerDrag ) {

            _layerDrag = new EHDI.aka.Container();

            if ( _parent ) _parent.addChild( _layerDrag );
        }
      




                        // _touchTest =new EHDI.displays.FillRectangle( 0x00FF00, 0,0,1024,600);
                        // _touchTest.interactive = true;

                        // var _handler_touchBegin = function(e)
                        // {
                        //     console.log("touch begin");
                        //     console.log(e.identifier, e.data.identifier);

                        //     //e.identifier is null
                        //     //e.data.identifier works, map this to the animals
                        //     // save target animal to   map
                        // }

                        // _parent.addChild(_touchTest)

                        
                        // _touchTest.on( "touchstart", _handler_touchBegin );






        // ** Initialize bg
        if ( !_sprBG ) {

            // Get image according to 
            _sprBG = new EHDI.aka.Sprite( EHDI.Assets.images[ "assets/game/img_game_bg.png" ] );
            
            if ( _layerBG ) _layerBG.addChild( _sprBG );
        }

        // ** Add cages
        if ( !_objCages ) {

            _objCages = [];
            scoreEffectXs = [];

            for ( var cageCount = 1; cageCount <= 2; cageCount++ ) {

                var cageType;

                if ( cageCount === 1 ) cageType = APP.game.AnimalType.GOAT;
                else if ( cageCount === 2 ) cageType = APP.game.AnimalType.SHEEP;
                var objCage = new APP.game.CageObject( cageType );

                if ( cageCount === 1 ) objCage.x = ( objCage.width * 0.5 ) + 10;
                else if ( cageCount === 2 ) objCage.x = APP.config.stageWidth - ( objCage.width  * 0.5 ) - 10;
                objCage.y = 200+objCage.height;//( APP.config.stageHeight * 0.55 )  + ( objCage.height * 0.5 );

                _objCages.push( objCage );

                if ( _layerBG ) _layerBG.addChild( objCage );
            }
        }

        // Get cage references
        var objCage_left = _objCages[ 0 ];
        var objCage_right = _objCages[ 1 ];

        // ** Initialize fence left
        if ( !_sprFenceLeft_back ) {

            _sprFenceLeft_back = new EHDI.aka.Sprite( EHDI.Assets.images[ "assets/game/img_fence_back.png" ] );
            _sprFenceLeft_back.anchor.set( 0.5, 1 );
            _sprFenceLeft_back.position.set( objCage_left.x, objCage_left.y - objCage_left.height + 10 );

            if ( _layerObjects ) _layerObjects.addChild( _sprFenceLeft_back );
        }

        if ( !_sprFenceLeft_front ) {

            _sprFenceLeft_front = new EHDI.aka.Sprite( EHDI.Assets.images[ "assets/game/img_fence_front.png" ] );
            _sprFenceLeft_front.anchor.set( 0.5, 1 );
            _sprFenceLeft_front.position.set( objCage_left.x, objCage_left.y + 10 );

            if ( _layerObjects ) _layerObjects.addChild( _sprFenceLeft_front );
        }

        // ** Initialize fence right
        if ( !_sprFenceRight_back ) {

            _sprFenceRight_back = new EHDI.aka.Sprite( EHDI.Assets.images[ "assets/game/img_fence_back.png" ] );
            _sprFenceRight_back.anchor.set( 0.5, 1 );
            _sprFenceRight_back.position.set( objCage_right.x, objCage_right.y - objCage_right.height + 10 );

            if ( _layerObjects ) _layerObjects.addChild( _sprFenceRight_back );
        }

        if ( !_sprFenceRight_front ) {

            _sprFenceRight_front = new EHDI.aka.Sprite( EHDI.Assets.images[ "assets/game/img_fence_front.png" ] );
            _sprFenceRight_front.anchor.set( 0.5, 1 );
            _sprFenceRight_front.position.set( objCage_right.x, objCage_right.y + 10 );
            _sprFenceRight_front.scale.x = -1;

            if ( _layerObjects ) _layerObjects.addChild( _sprFenceRight_front );
        }

        // ** Initialize signs
        if ( !_sprSign_left ) {

            _sprSign_left = new EHDI.aka.Sprite( EHDI.Assets.images[ "assets/game/img_sign_1.png" ] );
            _sprSign_left.anchor.set( 0.5, 1 );
            _sprSign_left.position.set( _sprFenceLeft_back.x + ( _sprFenceLeft_back.width * 0.5 ) + ( _sprSign_left.width * 0.25 ), 
                                    _sprFenceLeft_back.y + ( _sprFenceLeft_back.height * 0.325 ) );
                                    //_sprFenceLeft_back.y - ( _sprFenceLeft_back.height * 0.325 ) );
            
            scoreEffectXs.push(_sprSign_left.position.x);
            scoreEffectY = _sprSign_left.position.y;

            if ( _layerObjects ) _layerObjects.addChild( _sprSign_left );
        }

        if ( !_sprSign_right ) {

            _sprSign_right = new EHDI.aka.Sprite( EHDI.Assets.images[ "assets/game/img_sign_2.png" ] );
            _sprSign_right.anchor.set( 0.5, 1 );
            _sprSign_right.position.set( _sprFenceRight_back.x - ( _sprFenceRight_back.width * 0.5 ) - ( _sprSign_right.width * 0.25 ), 
                                     _sprFenceRight_back.y + ( _sprFenceRight_back.height * 0.325 ) );
                                    // _sprFenceRight_back.y - ( _sprFenceRight_back.height * 0.325 ) );

            scoreEffectXs.push(_sprSign_right.position.x);

            if ( _layerObjects ) _layerObjects.addChild( _sprSign_right );
        }

        
        scoreEffects = new EHDI.components.ScoreEffectManager();
        if ( _layerObjects )
            scoreEffects.init(_layerObjects);

        // ** Create spawn areas
        if ( !_grpSpawn_bottom ) {

            // Draw graphics
            _grpSpawn_bottom = new EHDI.aka.Graphics();
            _grpSpawn_bottom.clear();

            _grpSpawn_bottom.beginFill( 0x00FF00 );

            _grpSpawn_bottom.drawRect( 0, 0, APP.config.stageWidth, 
                            APP.config.stageHeight - Math.max( _sprFenceLeft_front.y, _sprFenceRight_front.y ) - 10 );
            _grpSpawn_bottom.endFill();

            _grpSpawn_bottom.position.set( 0, APP.config.stageHeight - _grpSpawn_bottom.height );
            _grpSpawn_bottom.alpha = 0.5;

            if ( APP.game.debugEnabled === true ) _grpSpawn_bottom.visible = true;
            else _grpSpawn_bottom.visible = false;
            
            if ( _layerBG ) _layerBG.addChild( _grpSpawn_bottom );
        }

        if ( !_grpSpawn_top ) {

            // Draw graphics
            _grpSpawn_top = new EHDI.aka.Graphics();
            _grpSpawn_top.clear();

            _grpSpawn_top.beginFill( 0x00FF00 );

            _grpSpawn_top.drawRect( 0, 0, APP.config.stageWidth, 
                            Math.min( _sprFenceLeft_back.y - ( _sprFenceLeft_back.height * 0.25 ), _sprFenceRight_back.y - ( _sprFenceRight_back.height * 0.25 ) ) - 10 );
            _grpSpawn_top.endFill();

            _grpSpawn_top.position.set( 0, 0 );
            _grpSpawn_top.alpha = 0.5;

            if ( APP.game.debugEnabled === true ) _grpSpawn_top.visible = true;
            else _grpSpawn_top.visible = false;
            
            if ( _layerBG ) _layerBG.addChild( _grpSpawn_top );
        }

        if ( !_objAnimals ) {

            _objAnimals = [];
            
            var spawnCount = 20;
            var spawnPerType = spawnCount / _objCages.length;

            var lastSpawnArea;

            for ( var countAnimal = 0; countAnimal < spawnCount; countAnimal++ ) {

                var typeAnimal = Math.floor( ( spawnPerType + countAnimal ) / spawnPerType );

                var objAnimal = new APP.game.AnimalObject( typeAnimal, _parent );

                // // Get random spawn area
                // var randSpawnArea = Math.round( EHDI.NumberUtil.randomRange( 1, 2 ) );

                // do { randSpawnArea = Math.round( EHDI.NumberUtil.randomRange( 1, 2 ) ); }
                // while ( randSpawnArea == lastSpawnArea );

                // // Set last spawn area
                // lastSpawnArea = randSpawnArea;

                // // Set random position within bounds
                // if ( randSpawnArea === 1 ) {

                //     // Set random position via top spawn
                //     objAnimal.x = EHDI.NumberUtil.randomRange( _grpSpawn_top.x + ( objAnimal.width * 0.5 ), ( _grpSpawn_top.x + _grpSpawn_top.width ) - ( objAnimal.width * 0.5 ) );
                //     objAnimal.y = EHDI.NumberUtil.randomRange( _grpSpawn_top.y + objAnimal.height, _grpSpawn_top.y + _grpSpawn_top.height );
                // }
                // else if ( randSpawnArea === 2 ) {

                //     // Set random position via bottom spawn
                //     objAnimal.x = EHDI.NumberUtil.randomRange( _grpSpawn_bottom.x + ( objAnimal.width * 0.5 ), ( _grpSpawn_bottom.x + _grpSpawn_bottom.width ) - ( objAnimal.width * 0.5 ) );
                //     objAnimal.y = EHDI.NumberUtil.randomRange( _grpSpawn_bottom.y + 10, _grpSpawn_bottom.y + _grpSpawn_bottom.height );
                // } 

                
                // Set random position via bottom spawn
                objAnimal.x = EHDI.NumberUtil.randomRange( _grpSpawn_bottom.x + ( objAnimal.width * 0.5 ), ( _grpSpawn_bottom.x + _grpSpawn_bottom.width ) - ( objAnimal.width * 0.5 ) );
                objAnimal.y = EHDI.NumberUtil.randomRange( _grpSpawn_bottom.y + 10, _grpSpawn_bottom.y + _grpSpawn_bottom.height );
                
                // Push to list
                _objAnimals.push( objAnimal );

                // Add to layer
                if ( _layerObjects ) _layerObjects.addChild( objAnimal );
            }
            
        }

        var objAnimal = new APP.game.AnimalObject( APP.game.AnimalType.LION, _parent );
        // Add to layer
        if ( _layerObjects ) _layerObjects.addChild( objAnimal );
        _lion = objAnimal;
        APP.game.lion = _lion;


        
        _sparkleArmature = EHDI.DBoneFactory.createArmature("sparkle_armature");
        _sparkleAnimationSprite = _sparkleArmature.getDisplay();
        _sparkleAnimationSprite.visible = false;

        
        if ( _layerObjects ) _layerObjects.addChild( _sparkleAnimationSprite );


        
        
        // Rearrange objects
        _rearrangeObjects();
    };

    var _lionSparkle = function(xPos, yPos)
    {
        _sparkleAnimationSprite.x = xPos;
        _sparkleAnimationSprite.y = yPos;
        _sparkleAnimationSprite.visible = true;
        
        _sparkleArmature.animation.gotoAndPlay("fx_sparkle", -1, -1, 1);
    }
    this.lionSparkle = _lionSparkle;

    var _initListeners_primary = function () {

        // Register game events
        APP.managers.event.register( APP.game.LevelEvent.START );
        APP.managers.event.register( APP.game.LevelEvent.END );
        APP.managers.event.register( APP.game.LevelEvent.UPDATED_SCORE );

        APP.managers.event.register( APP.game.AnimalEvent.DRAG_START );
        APP.managers.event.register( APP.game.AnimalEvent.DRAG_END );
        APP.managers.event.register( APP.game.AnimalEvent.MOVING );
        APP.managers.event.register( APP.game.AnimalEvent.UPDATED_STATE );
    }

    var _initListeners = function () {

        // Add frame listeners
        APP.managers.update.addFrameListener( _handler_frameUpdate );

        // Add satelite listeners
        APP.managers.event.addListener( APP.game.AnimalEvent.DRAG_START, _handlerAnimal_dragStart );
        APP.managers.event.addListener( APP.game.AnimalEvent.DRAG_END, _handlerAnimal_dragEnd );
        APP.managers.event.addListener( APP.game.AnimalEvent.MOVING, _handlerAnimal_moving );


        
        if ( EHDI.BrowserInfo.isMobileDevice ) {            
            _interactionMan.on( "touchmove", _interactionLayer_move );
        }
        else {

            _interactionMan.on( "mousemove", _interactionLayer_move );
        }
    };

    // ** Kill Methods

    var _killProps = function () {

        _isPaused = null;
        _score = null;
        APP.game.lion = null;
        _interactionMan = null;
    };

    var _killGraphics = function () {

        // ** Kill BG
        if ( _sprBG ) {

            if ( _sprBG.parent ) _sprBG.parent.removeChild( _sprBG );

            _sprBG.destroy( { children: true } );
        }
        _sprBG = null;

        // ** Kill fence left
        if ( _sprFenceLeft_back ) {

            if ( _sprFenceLeft_back.parent ) _sprFenceLeft_back.parent.removeChild( _sprFenceLeft_back );

            _sprFenceLeft_back.destroy( { children: true } );
        }
        _sprFenceLeft_back = null;

        if ( _sprFenceLeft_front ) {

            if ( _sprFenceLeft_front.parent ) _sprFenceLeft_front.parent.removeChild( _sprFenceLeft_front );

            _sprFenceLeft_front.destroy( { children: true } );
        }
        _sprFenceLeft_front = null;
        
        // ** Kill fence right
        if ( _sprFenceRight_back ) {

            if ( _sprFenceRight_back.parent ) _sprFenceRight_back.parent.removeChild( _sprFenceRight_back );

            _sprFenceRight_back.destroy( { children: true } );
        }
        _sprFenceRight_back = null;

        if ( _sprFenceRight_front ) {

            if ( _sprFenceRight_front.parent ) _sprFenceRight_front.parent.removeChild( _sprFenceRight_front );

            _sprFenceRight_front.destroy( { children: true } );
        }
        _sprFenceRight_front = null;

        // ** Kill signs
        if ( _sprSign_left ) {

            if ( _sprSign_left.parent ) _sprSign_left.parent.removeChild( _sprSign_left );

            _sprSign_left.destroy( { children: true } );
        }
        _sprSign_left = null;

        if ( _sprSign_right ) {

            if ( _sprSign_right.parent ) _sprSign_right.parent.removeChild( _sprSign_right );

            _sprSign_right.destroy( { children: true } );
        }
        _sprSign_right = null;

        // ** Kill cages
        var i;
        if ( _objCages ) {

            for ( i = 0; i < _objCages.length; i++ ) {

                var objCage = _objCages[ i ];

                if ( objCage.parent ) objCage.parent.removeChild( objCage );

                objCage.destroy( { children: true } );

                _objCages[ i ] = null;
            }

            _objCages.splice( 0, _objCages.length );
        }
        _objCages = null;

        // ** Kill animals
        if ( _objAnimals ) {

            for ( i = 0; i < _objAnimals.length; i++ ) {

                var objAnimal = _objAnimals[ i ];

                if ( objAnimal.parent ) objAnimal.parent.removeChild( objAnimal );

                objAnimal.destroy( { children: true } );

                _objAnimals[ i ] = null;
            }

            _objAnimals.splice( 0, _objAnimals.length );
        }
        _objAnimals = null;

        if ( _layerBG ) {

            if ( _layerBG.parent ) _layerBG.parent.removeChild( _layerBG );

            _layerBG.destroy( { children: true } );
        }
        _layerBG = null;

        if ( _layerObjects ) {

            if ( _layerObjects.parent ) _layerObjects.parent.removeChild( _layerObjects );

            _layerObjects.destroy( { children: true } );
        }
        _layerObjects = null;

        if ( _layerDrag ) {

            if ( _layerDrag.parent ) _layerDrag.parent.removeChild( _layerDrag );

            _layerDrag.destroy( { children: true } );
        }
        _layerDrag = null;

    };

    var _killListeners_primary = function () {

        // Unregister game events
        APP.managers.event.unregister( APP.game.LevelEvent.START );
        APP.managers.event.unregister( APP.game.LevelEvent.END );
        APP.managers.event.unregister( APP.game.LevelEvent.UPDATED_SCORE );

        APP.managers.event.unregister( APP.game.AnimalEvent.DRAG_START );
        APP.managers.event.unregister( APP.game.AnimalEvent.DRAG_END );
        APP.managers.event.unregister( APP.game.AnimalEvent.MOVING );
        APP.managers.event.unregister( APP.game.AnimalEvent.UPDATED_STATE );
    }

    var _killListeners = function () {

        // Remove frame listeners
        APP.managers.update.removeFrameListener( _handler_frameUpdate );

        // Remove satelite listeners
        APP.managers.event.removeListener( APP.game.AnimalEvent.DRAG_START, _handlerAnimal_dragStart );
        APP.managers.event.removeListener( APP.game.AnimalEvent.DRAG_END, _handlerAnimal_dragEnd );
        APP.managers.event.removeListener( APP.game.AnimalEvent.MOVING, _handlerAnimal_moving );
        
         
        if ( EHDI.BrowserInfo.isMobileDevice ) {            
            _interactionMan.off( "touchmove", _interactionLayer_move );
        }
        else {

            _interactionMan.off( "mousemove", _interactionLayer_move );
        }
    };

    // Public Methods

    this.destroy = function () {
        
        // Kill listeners
        _killListeners();

        // Kill graphics
        _killGraphics();

        // Kill primary listeners
        _killListeners_primary();

        // Kill props
        _killProps();

        // Call superclass method
        APP.game.LevelObject.prototype.destroy.apply( this, arguments );
    };

    // Call init methods
    _initProps();
    _initListeners_primary();
    _initGraphics();
    _initListeners();

    Object.defineProperties( _parent, {
        "score": {
            get: function () { return _score; },
            enumerable: true
        },
        "check": {
            get: function () { return _updateScore; },
            enumerable: true
        },
        "paused": {
            get: function () { return _isPaused; },
            set: function ( p_value ) {

                if ( p_value !== true &&
                    p_value !== false ) throw "Pause value should be boolean.";

                if ( _isPaused === p_value ) return;

                // Set isPaused
                _isPaused = p_value;
                var i = 0;
                if ( _isPaused === true ) {
                    
                    if ( _objAnimals ) {

                        for ( i = 0; i < _objAnimals.length; i++ ) {
                            if ( _objAnimals[ i ] ) _objAnimals[ i ].paused = true;
                        }
                    }

                    if(_lion)
                        _lion.paused = true;

                }
                else if ( _isPaused === false ) {

                    if ( _objAnimals ) {

                        for ( i = 0; i < _objAnimals.length; i++ ) {
                            if ( _objAnimals[ i ] ) _objAnimals[ i ].paused = false;
                        }
                    }

                    if(_lion)
                        _lion.paused = false;
                }
                
            },
            enumerable: true
        },
        "spawnBottom": {
            get: function () { return _grpSpawn_bottom; },
            enumerable: true
        },
        "spawnTop": {
            get: function () { return _grpSpawn_top; },
            enumerable: true
        },
    });
  
    APP.game.cages = _objCages;
    // Return
    return _parent;
};
APP.game.TouchObjects = Object.create(null);
APP.game.TouchObjects.count = 0;
APP.game.LevelObject.prototype = Object.create( EHDI.aka.Container.prototype );
APP.game.LevelObject.prototype.constructor = APP.game.LevelObject;